module.exports = __webpack_public_path__ + "img/logoFestivalSD.b6955a0b.png";